var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("filter-base", {
    attrs: {
      options: _vm.allowedHospitals,
      allClears: !_vm.isTSSiteUser,
      allDefaultIDs: _vm.userHospitalIDs,
      label: "Hospitals",
      customText: _vm.selectedText,
      shortenText: ""
    },
    on: {
      selectedIDs: function($event) {
        _vm.selectedIDs = $event
      }
    },
    model: {
      value: _vm.hospitals,
      callback: function($$v) {
        _vm.hospitals = $$v
      },
      expression: "hospitals"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }